
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { dropMenuProject } from '@/types/dropMenu';
import CommonDropMenuOverlay from './CommonDropMenuOverlay';
@Component
export default class CommonDropMenu extends Vue {
  // 传递的是展示的数组
  @Prop() private list!: dropMenuProject[];
  // 用于展示的默认值
  @Prop() private defaultValue!: string;
  // 用于定位选择蒙层的位置
  @Prop() private position!: 'left' | 'right' | 'center';
  @Prop() private size!: string;
  // 是否禁止切换滚动到顶部
  @Prop({ default: false }) private disableChangeScroll: boolean;
  @Watch('defaultValue')
  onChange() {
    if (!this.disableChangeScroll) {
      window.scrollTo(0, 0);
    }
    this.selected = this.defaultValue;
  }
  selected = '';
  // 是否为激活的状态
  isActive = false;
  get selectedLabel() {
    const select = this.selected === '无' ? '筛选' : this.selected;
    return select || this.defaultValue;
  }
  // 设置当前被激活的索引，同时
  handleBtnClick() {
    // 切换当前的选择激活状态
    this.isActive = !this.isActive;
    const Overlay = Vue.extend(CommonDropMenuOverlay);
    const btnRef = this.$refs.dropbtn as HTMLElement;
    const iconRef = this.$refs.dropicon as HTMLElement;
    // 计算定位位置
    const { left, top, height } = btnRef.getBoundingClientRect();
    const iconLeft = iconRef.getBoundingClientRect().left;
    const dpr = this.$dpr;
    const positionObj = {
      top: `${top + height + 8 * dpr}px`,
      left: '0',
      right: '0',
    };
    // 计算箭头的定位位置
    const arrowPosition = {
      top: `${top + height + 6 * dpr}px`,
      left: `${iconLeft + 4 * dpr}px`,
    };
    // 定位类型判断 左右/中间
    if (this.position === 'center') {
      // 计算左右位置
      positionObj.left = `${left}px`;
    } else if (this.position === 'left') {
      // 左定位8px
      positionObj[this.position] = `${8 * dpr}px`;
    } else {
      // 右定位8px
      positionObj.left = 'auto';
      positionObj[this.position] = `${8 * dpr}px`;
    }
    // 触发弹窗
    const tempElement = new Overlay({
      propsData: {
        list: this.list,
        unActive: () => {
          this.isActive = false;
        },
        menuClick: (item: dropMenuProject) => {
          if (this.selected === item.label) {
            return;
          }
          this.selected = item.label;
          //去触发事件
          this.$emit('selected', item);
        },
        position: positionObj,
        arrowPosition,
        selected: this.selected,
      },
    }).$mount();
    document.body.appendChild(tempElement.$el);
  }
  mounted() {
    // 设置默认
    this.selected = this.defaultValue;
  }
}
